import * as React from "react";
import { forwardRef } from "react";
const SvgDataTrimOutline = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 3V4.552H6.20801V21H8.00002V4.552H14.208V3H0ZM22.756 7.14845L24 8.41245L20.4698 12.0005L24 15.5885L22.756 16.8525L19.226 13.2646L15.696 16.8525L14.452 15.5885L17.9822 12.0005L14.452 8.41245L15.696 7.14845L19.226 10.7363L22.756 7.14845Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgDataTrimOutline);
export { ForwardRef as ReactComponent };
